// extracted by mini-css-extract-plugin
export default {"formula":"H1c1e","formula__fields":"nXhus","formula__editor":"FL5f7","formula__controllers":"Lcmsi","appear-from-above":"df8FP","appearFromAbove":"df8FP"};